

































































































































import {Vue, Component, Watch, Prop} from "vue-property-decorator";
import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
    BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'

import {UserService} from "@/modules/partners/services/user.service";
import {User, Skill} from "@/modules/core/models";

@Component({
    components: {TiptapVuetify},
})
export default class PartnerDetail extends Vue {

    @Prop(Number)
    id: number | undefined; //id

    isDataLoaded = false;

    user: User = null;

    initial_message = `
        <p>Bienvenido a flowlemon!</p>
        <p>Preséntate con pasión en unas pocas líneas. Explica tus habilidades técnicas y las competencias intrapersonales que te caracterizan, incluso los sectores en los que te gustaría trabajar.
        </p>
        <p>Te recomendamos hacer un listado con las tareas que tu sabrías realizar de forma independiente, por ejemplo:</p>
        <ul>
            <li><p>Campañas de Marketing Online (Facebook, Google Ads, ...)</p></li>
            <li><p>Creador de comunidades</p></li>
            <li><p>Desarrollador de aplicaciones</p></li>
            <li><p>Etc...</p></li>
        </ul>
        `;

    get pk() {
        if (this.id === undefined) {
            let pk = Number(this.$route.params.id);
            if (isNaN(pk)) {
                console.log("pk is not defined");
                this.$router.push({name: "home"})
            }
            return pk;
        }
        return this.id;
    }

    async created() {
        this.user = await UserService.get_current_user();
        console.log(this.user);
        if (this.user.description === "") {
            this.user.description = this.initial_message;
        }
        this.new_content = this.user.description;
        this.isDataLoaded = true;
    }

    get get_avatar_image() {
        const background_colors = ['F9A825', '224177', '00838F', '9C27B0'];

        let random_color = background_colors[Math.floor(Math.random() * 3)];

        return `https://eu.ui-avatars.com/api/?name=${this.user.name}+${this.user.surname}&rounded=true&size=128&background=${random_color}&color=fff`
    }

    //Dialogs
    dialog_edit_description = false;

    extensions = [
        History,
        Bold,
        Italic,
        Underline,
        Strike,

        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
            options: {
                levels: [2, 3, 4]
            }
        }],
        HorizontalRule
    ];
    // starting editor's content
    new_content = "";

    cancel_description_edit() {
        this.new_content = this.user.description;
        this.dialog_edit_description = false;
    }

    save_description_edit() {

        if (this.new_content.length > 800) {
            this.$store.dispatch("snackbar/activate", {
                message: "El texto no puede ser superior a 500 caracteres",
                code: 1
            });
            return null
        }

        this.user.description = this.new_content;
        // call to API to update description field
        UserService.patch(this.user.pk, JSON.parse(JSON.stringify({"description": this.new_content})));
        this.dialog_edit_description = false;
    }


}
